import { networkCommon as listeners, on, off } from "../../../web/manager/system/networkCommon";
import { webmafAction, addEventListener } from "../webmafActions";

const networkStatus = {
  connected: "networkConnected",
  disconnected: "networkDisconnected"
};

let status = "unknown";

function triggerListeners(networkState) {
  // FIXME: We have this code repeated more than twice. Move it to a single place with this logic and use it from every place we duplicate now
  const state = networkState.toLowerCase();
  status = networkStatus[state];
  listeners[status] && listeners[status].forEach(listener => listener());
}

function bindNetworkStatusChange() {
  addEventListener("networkStatusChange", ({ newState }) => {
    triggerListeners(newState);
  });
}

bindNetworkStatusChange();

export const network = {
  async getStatus() {
    return status === networkStatus.connected;
  },

  async getIp() {
    return WM_devSettings.deviceIP;
  },

  async getConnectionType() {
    return new Promise(resolve => {
      webmafAction("getDeviceInfo", {}, ({ connectionType }) => {
        resolve(connectionType);
      });
    });
  },

  async getMac() {
    return "";
  },

  on,
  off
};
